import React, {useEffect} from "react";
import styled from "styled-components";
import {useSelector} from "react-redux";
import {ALL_FILTER} from "../../tab/filterTypes";

const AxisContainer = ({setProjectsSelected, selectedSection, axisSelected, setAxisSelected}) => {

    const {projects} = useSelector(state => state.projects)
    const {axis} = useSelector(state => state.axis)

    useEffect(() => {
        if (selectedSection.key === ALL_FILTER){
            setProjectsSelected(projects)
        } else {
            setProjectsSelected(projects.filter(p => parseInt(p.endDate?.slice(0, 4)) === selectedSection.label))
        }
        setAxisSelected(0)
    }, [projects, selectedSection.key, selectedSection.label, setAxisSelected, setProjectsSelected])

    const filterByAxis = (axisId = 0) => {
        setAxisSelected(axisId)
        if (axisId === 0) {
            if (selectedSection.key !== ALL_FILTER){
                setProjectsSelected(projects
                    .filter(p => parseInt(p.endDate?.slice(0, 4)) === selectedSection.label)
                )
            } else {
                setProjectsSelected(projects)
            }
        } else {
            if (selectedSection.key !== ALL_FILTER){
                setProjectsSelected(projects
                    .filter(p => parseInt(p.endDate?.slice(0, 4)) === selectedSection.label)
                    .filter(p => p.stake?.axisId === axisId)
                )
            } else {
                setProjectsSelected(projects.filter(p => p.stake?.axisId === axisId))
            }
        }
    }

    return (
        <Container>
            <Button onClick={() => filterByAxis()}
                    className={axisSelected === 0 ? "selected" : ""}
            >
                <h6> Tous les axes </h6>
            </Button>
            {axis.map((a, index) => (
                <Button
                    key={index}
                    className={axisSelected === a.id ? "selected" : ""}
                    onClick={() => filterByAxis(a.id)}>
                    <h6> {a.name} </h6>
                </Button>
            ))}
        </Container>
    )
}
const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5em;
  justify-content: center;

  .selected {
    border: 2px solid var(--color-purple);
    color: var(--color-purple);

    h6 {
      color: solid var(--color-purple);
    }
  }
`

const Button = styled.button`
  border: 2px solid transparent;
  padding: 0.25em 1em;
  background-color: rgba(166, 172, 181, 0.1);
  border-radius: 10px;
  cursor: pointer;

  h6 {
    color: var(--color-dark);
  }

  &:hover, &:focus {
    border: 2px solid var(--color-purple);

    h6 {
      color: var(--color-purple);
    }
  }
`
export default AxisContainer